export const BASE_URL =
  process.env.REACT_APP_NODE_ENV === "development"
    ? process.env.REACT_APP_API_URL
    : process.env.REACT_APP_NODE_ENV === "testing"
    ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
    : `${window.location.protocol}//${window.location.hostname}`;
